import { UpdateDocuments } from '@/interfaces/license-mine-update/license-mine-update.interface';
import { Details, Document } from '@/interfaces/requirement';
import { LicenseMineUpdateService } from '@/services/license-mine-update/license-mine-update.service';
import { StoreState } from '@/store';
import { modalShow } from '@/store/modal/actions';
import { loaderAnimationHide, loaderAnimationShow } from '@/store/page-loader/action';
import { ofuscate } from '@/utils/obfuscation';
import { Component, Input, OnInit } from '@angular/core';
import { FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-license-mine-update-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css'],
})
export class DetailComponent implements OnInit {

  @Input() selectedPersonEmail: string = '';
  @Input() selectedPersonMdmid: string = '';
  @Input() mineDocumentTable: FormArray = new FormArray([]);

  requirementId: number = 0;
  licenseId: number = 0;

  /* Control manual de la informacion de app-license-detail */
  dataRequirement?: Details;
  dataRequirementGetting: boolean = true;
  dataRequirementError: boolean = false;

  mineDocuments?: Document[];

  get equipments(): Details['equipments'] {
    return this.dataRequirement?.equipments || [];
  }
  get documents(): Details['documents'] {
    return this.dataRequirement?.documents || [];
  }

  constructor(
    private router: Router,
    private store: Store<StoreState>,
    public route: ActivatedRoute,
    private licenseMineUpdate: LicenseMineUpdateService,
  ) { }

  ngOnInit(): void {
    if (this.selectedPersonMdmid) {
      this.licenseMineUpdate.getLicenseDetailByMdmid(this.selectedPersonMdmid).subscribe({
        next: (details) => {
          this.requirementId = details.id;
          this.licenseId = details.licenseId;
          this.dataRequirement = details;
          this.mineDocuments = details.documents;
          this.dataRequirementGetting = false;
        },
        error: () => {
          this.dataRequirementGetting = false;
          this.dataRequirementError = true;
        },
      });
    }
  }

  onSubmit() {
    this.store.dispatch(modalShow({
      title: '¿Estás seguro que quieres enviar esta actualización?',
      text: 'Si ya has revisado la información registrada y está correcta, continúa en Actualizar.',
      text2: 'De lo contrario, presiona  Volver para revisar la información.',
      acceptButtonText: 'Actualizar',
      actionOnAccept: () => {
        const params: UpdateDocuments = this.mineDocumentTable.value.map((mineDocument: any) => {
          if (mineDocument.isEnabled) {
            return {
              id: mineDocument.id,
              documentStatusId: +mineDocument.documentStatusId,
              dateFrom: mineDocument.dateFrom,
              dateTo: mineDocument.dateUntil,
            };
          }
          return {
            id: mineDocument.id,
            documentStatusId: +mineDocument.documentStatusId,
          };
        });
        // primer dispatch
        this.store.dispatch(loaderAnimationShow());
        this.licenseMineUpdate.updateDocuments(params, this.requirementId).subscribe({
          next: () => {
            const ofuscatedData = ofuscate({ email: this.selectedPersonEmail, id: this.requirementId, licenseId: this.licenseId });
            this.router.navigate([ofuscatedData], { relativeTo: this.route });
          },
          error: () => {
            this.store.dispatch(loaderAnimationHide());

            this.store.select('pageError').subscribe({
              next: (pageConfig) => {
                const [website, ...url] = window.location.href.split('//')[1].split('/');
                if (pageConfig.errorType !== 'Mulesoft') {

                  const ofuscatedData = ofuscate({ variant: 'failure' });
                  this.router.navigate([ofuscatedData], { relativeTo: this.route });

                }
              },
            });
          },
          complete: () => {
            // segundo dispatch
            this.store.dispatch(loaderAnimationHide());
          },

        });
      },
    }));
  }

}
